<script setup>
import { ref, onMounted, inject } from 'vue';

import HomeHero from '../components/home/HomeHero.vue';
import HeroSkeleton from '../components/home/HeroSkeleton.vue';
import HomeServices from '../components/home/HomeServices.vue';
import HomeIntroduction from '../components/home/HomeIntroduction.vue';
import HomeCompanyLogos from '../components/home/HomeCompanyLogos.vue';
import HomeGallery from '../components/home/HomeGallery.vue';
import HomeTestimonials from '../components/home/HomeTestimonials.vue';
import HomeCallToAction from '../components/home/HomeCallToAction.vue';
import BlogList from '../components/blog/BlogList.vue';
import TheParallax from '../components/TheParallax.vue';
import TheContact from '../components/TheContact.vue';
import { useHead } from '@vueuse/head';
import 'vue3-carousel/dist/carousel.css';

const { directusService } = inject('$directus');

const slider = ref(null);
const sliderLoading = ref(false);
const sliderError = ref(null);

async function fetchSlider() {
    sliderLoading.value = true;
    try {
        const response = await directusService.getHomepageSlider();
        slider.value = response;
    } catch (error) {
        console.error('Error fetching slider:', error);
        sliderError.value = error;
    } finally {
        sliderLoading.value = false;
    }
}

const testimonials = ref([]);
const testimonialsLoading = ref(false);
const testimonialsError = ref(null);

async function fetchTestimonials() {
    testimonialsLoading.value = true;
    try {
        const response = await directusService.getTestimonials({
            filter: {
                status: 'published',
            },
        });
        testimonials.value = response;
    } catch (error) {
        console.error('Error fetching testimonials:', error);
        testimonialsError.value = error;
    } finally {
        testimonialsLoading.value = false;
    }
}

const gallery = ref([]);
const galleryLoading = ref(false);
const galleryError = ref(null);

async function fetchGallery() {
    galleryLoading.value = true;
    try {
        const response = await directusService.getHomeGallery();
        gallery.value = response;
    } catch (error) {
        console.error('Error fetching gallery:', error);
        galleryError.value = error;
    } finally {
        galleryLoading.value = false;
    }
}

onMounted(async () => {
    await Promise.all([fetchSlider(), fetchGallery(), fetchTestimonials()]);
});

const pageTitle = ref(
    'Elysia Laser Clinic — Prémium minőségű vizsgálatok és kezelések Győrben.',
);
const pageDescription = ref(
    'Fedezd fel a legjobb vizsgálatainkat és kezeléseinket, tapasztalt szakembereink és korszerű technológiáink segítségével',
);

useHead({
    title: pageTitle.value,
    meta: [
        {
            name: 'description',
            content: pageDescription.value,
        },
        {
            property: 'og:title',
            content: pageTitle.value,
        },
        {
            property: 'og:description',
            content: pageDescription.value,
        },
        {
            property: 'og:url',
            content: 'https://elysia.hu/',
        },
    ],
});

const slides = ref([
    // {
    //   id: 1,
    //   title: "Üdvözlünk a honlapon!",
    //   // buttonText: "Áraink",
    //   linkTo: "araink",
    //   alt: "Hajmezoterápiás kezelés a központban.",
    //   text: "A legmodernebb technológiákkal és a legjobb szakemberekkel várjuk, hogy segítsünk Önnek megtalálni a megfelelő kezelést.",
    //   // list: [
    //   //   "2024. December 20. 8:30-12:30",
    //   //   "2024. December 21 - 2025 Január 5 között ZÁRVA TARTUNK",
    //   //   "2024. Január 6. 10:00-18:00",
    //   // ],
    //   img: "arvaltozas.jpg",
    //   imgTablet: "arvaltozas-tablet.jpg",
    //   imgMobile: "arvaltozas-mobil.jpg",
    // },
    {
        id: 2,
        title: 'Átfogó megoldások, állandó bőregészség',
        text: 'A ZO® Skin Health egyedülállóan hatékony prémium bőrterápiás és bőrápoló rendszer bőrproblémák teljes körű kezelésére.',
        img: 'hero-atfogo-kezeles.jpg',
        imgTablet: 'hero-atfogo-kezeles.jpg',
        imgMobile: 'hero-atfogo-kezeles.jpg',
    },
    // {
    //   id: 1,
    //   title: "Karácsonyi nyitvatartásunk",
    //   // buttonText: "Plasztikai sebészet",
    //   // linkTo:
    //   //   "szolgaltatasok/plasztikai-sebeszet/anyajegy-eltavolitasa-szovettani-vizsgalattal",
    //   alt: "Egy fenyőfadísz, amit könnyedén tart egy női kéz.",
    //   // text: "Akár esztétikai, akár egészségügyi okból történik az anyajegy eltávolítása, minden esetben plasztikai sebész által végzett sebészeti eljárást alkalmazunk.",
    //   list: [
    //     "2025. December 23. - 2026. Január 4.-ig ZÁRVA.",
    //     "Nyitás: 2026. Január 5-én.",
    //   ],
    //   img: "xmas2025-desktop.jpg",
    //   imgTablet: "xmas2025-tablet.jpg",
    //   imgMobile: "xmas2025-mobil.jpg",
    // },
    {
        id: 4,
        title: 'Élvezze gyönyörű és sima bőrét egész évben',
        // buttonText: "Bőrgyógyászat",
        linkTo: 'szolgaltatasok/lezerkezelesek/lezeres-szortelenites',
        alt: 'Lézeres szőrtelenítés az Elysia Laser központban',
        text: 'Lézeres szőrtelenítés a legújabb technológiával Győrben. Intsen búcsút a makacsul visszatérő, benőtt szőrszálaknak!',
        img: 'hero-lezeres-szortelenites.jpg',
        imgTablet: 'hero-lezeres-szortelenites-tablet.jpg',
        imgMobile: 'hero-lezeres-szortelenites-mobil.jpg',
    },
    // {
    //   id: 3,
    //   title: "Intim lézeres kezelés 10% kedvezménnyel",
    //   // buttonText: "Bőrgyógyászat",
    //   linkTo: "szolgaltatasok/lezerkezelesek/intim-lezeres-kezelesek",
    //   alt: "Egy fényes bőrű, mosolygós göndör hajú nő",
    //   text: "Az első természetes technológia a hüvely sorvadásának kezelésére. Most bérlet vásárlása esetén 10% kedvezményt adunk a kezelés árából.",
    //   img: "hero-intim-lezeres-kezeles.jpg",
    //   imgTablet: "hero-intim-lezeres-kezeles-tablet.jpg",
    //   imgMobile: "hero-intim-lezeres-kezeles-mobil.jpg",
    // },
    {
        id: 5,
        title: 'Alsó és felső szemhéjplasztika',
        // buttonText: "Bőrgyógyászat",
        linkTo: 'szolgaltatasok/plasztikai-sebeszet/also-felso-szemhejplasztika',
        alt: 'Speciális fejbőr injekciózás egy nőn a kopaszodás és hajhullás ellen',
        text: 'Célja az esztétikai és funkcionális helyreállítás, a szem körüli szövetek eredeti állapothoz közeli műtéti rekonstrukciója. Látási nehezítettség esetén megszünteti a panaszokat is.',
        img: 'hero-szemhejplasztika.jpg',
        imgTablet: 'hero-szemhejplasztika-tablet.jpg',
        imgMobile: 'hero-szemhejplasztika-mobil.jpg',
    },
    {
        id: 6,
        title: 'Anyajegy eltávolítása szövettani vizsgálattal',
        // buttonText: "Plasztikai sebészet",
        linkTo: 'szolgaltatasok/plasztikai-sebeszet/anyajegy-eltavolitasa-szovettani-vizsgalattal',
        alt: 'Egy nő és egy férfi anyajegyekkel a hátukon',
        text: 'Akár esztétikai, akár egészségügyi okból történik az anyajegy eltávolítása, minden esetben plasztikai sebész által végzett sebészeti eljárást alkalmazunk.',
        // list: [],
        img: 'hero-anyajegy-eltavolitas-desktop.jpg',
        imgTablet: 'hero-anyajegy-eltavolitas-tablet.jpg',
        imgMobile: 'hero-anyajegy-eltavolitas-mobil.jpg',
    },
]);
</script>

<template>
    <section>
        <HeroSkeleton v-if="sliderLoading || !slider" />
        <HomeHero v-else :slides="slider" />
        <section>
            <HomeServices title="Kiemelt szolgáltatások">
                <template #description>
                    Jól képzett orvosaink, magas színvonalon, csúcsminőségű
                    készülékeink segítségével végzik az Ön számára leginkább
                    megfelelő kezeléseket. Az Ön elégedettsége a mi motivációnk.
                </template>
            </HomeServices>
        </section>
        <section>
            <HomeIntroduction
                title="Komplex szolgáltatások exkluzív környezetben"
            >
                <template #introduction>
                    Az Elysia Laser Clinic Győrben, Révfalu szívében
                    elhelyezkedő, barátságos környezetű, magas minőséget
                    képviselő magánklinika. Célunk, hogy továbbra is úgy
                    képviselhessük az esztétika és egészségügy világát, ahol
                    figyelnek a páciensre, ahova szívesen jön az ember, mert
                    minőséget és odafigyelést kap. Az esztétikus megjelenés
                    hívei vagyunk, nem a szélsőséges megnyilvánulásoké. Fontos
                    számunkra a folyamatos visszajelzés pácienseinktől, mert
                    ezek adják klinikánk lelkét.<br /><br />
                    A megyében egyedülálló ZO Skin Health partnerek vagyunk és
                    talán joggal mondhatjuk, hogy az elsők között voltunk, akik
                    a lézeres kezeléseket elindították Győrben, többek között a
                    végleges lézeres szőrtelenítést, a seprűvéna kezelést, egyéb
                    bőrnövedékek, szemölcsök eltávolítását valamint lézeres
                    hüvely rejuvenációt. A rengeteg pozitív visszajelzés
                    folyamatosan inspirál bennünket, hogy álljunk ki
                    elképzeléseink és jövőbeni terveink mellett. Ha Ön is az
                    Elysiaban jár, reméljük, hasonlóan nagyszerű tapasztalatai
                    lesznek, bízunk a közös együttműködésben!<br />
                </template>
            </HomeIntroduction>
        </section>
        <HomeCompanyLogos />
        <HomeGallery
            title="Galéria"
            :gallery="gallery[0]?.kepek"
            :loading="galleryLoading"
        />
        <HomeTestimonials
            title="Rólunk mondták"
            :testimonials
            :loading="testimonialsLoading"
        />
        <section>
            <HomeCallToAction />
        </section>
        <BlogList title="Tudjon meg többet szolgáltatásainkról" />
        <!-- parallax -->
        <TheParallax />
        <TheContact title="Foglalja le időpontját pár kattintással!" />
    </section>
</template>
